export const brokerTypesOptions = [
  { label: 'Corredor Alfa', value: 'alfa' },
  { label: 'Corredor Beta', value: 'beta' }
];

export const adminBrokerTypesOptions = [
  { label: 'Corredor Sigma', value: 'sigma' },
  { label: 'Corredor Alfa', value: 'alfa' }
];
